import { useState, useEffect } from "react";

/** Aligns with Tailwind `md` (768px). */
export const MD_UP_QUERY = "(min-width: 768px)";
export const MD_DOWN_QUERY = "(max-width: 767.98px)";

/** Aligns with Tailwind `lg` (1024px). Used by the site header so tablets get the
 *  hamburger drawer (the 6-item flat menu only fits comfortably from lg up). */
export const LG_UP_QUERY = "(min-width: 1024px)";

/**
 * Subscribes to window.matchMedia; updates when the breakpoint changes (e.g. rotation).
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(query);
    const onChange = () => setMatches(media.matches);
    onChange();
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

export function useIsMobileViewport() {
  const isDesktop = useMediaQuery(MD_UP_QUERY);
  return !isDesktop;
}
